import DOMPurify from 'dompurify'

/** Stored content is untrusted even when it predates the upload validator. */
export function safeMarkup(html: string): string {
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true, svg: true, mathMl: true },
    FORBID_TAGS: ['style', 'a', 'form', 'input', 'button', 'textarea', 'select'],
    FORBID_ATTR: ['style', 'id', 'name'],
  })
}
